import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import ConnectWallet from "../ConnectWallet";

// ---------------------------------------------------------------------
const ContainerStyle = styled("div")(({ theme }) => ({
  padding: "15px",
  borderBottom: "1px solid #ffffff80",
}));

const TitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "70px",
  fontFamily: "Helvetica",
}));

const SubTitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "50px",
  fontFamily: "Helvetica",
}));

const ContentStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "20px",
  fontFamily: "Helvetica",
  lineHeight: 1.2,
  paddingBottom: "15px",
}));

const TextFlowStyle = styled("div")(({ theme }) => ({
  overflow: "hidden",
  backgroundColor: "#fff",
  width: "100%",

  "@keyframes scrolling-left1": {
    "0%": {
      transform: "translateX(100%)",
    },
    "100%": {
      transform: "translateX(-100%)",
    },
  },

  "@keyframes scrolling-left2": {
    "0%": {
      transform: "translateX(0%)",
    },
    "100%": {
      transform: "translateX(-200%)",
    },
  },
}));

const TextFlowContentStyle = styled("p")(({ theme }) => ({
  fontFamily: "Helvetica",
  color: "#000",
  width: "100%",
  whiteSpace: "nowrap",
  padding: "8px 0",
}));

const TextAStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left1 40s linear infinite",
}));

const TextBStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left2 40s linear infinite",
  animationDelay: "20s",
}));

export default function TokenMobileContent({
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
}) {
  return (
    <Stack sx={{ mt: "90px" }}>
      <ContainerStyle>
        <SubTitleStyle>BECOME A CULTURE MAKER</SubTitleStyle>
      </ContainerStyle>

      <ContainerStyle>
        <ContentStyle sx={{ pb: 0 }}>
          WE INCUBATE COMMUNITY-OWNED BRANDS AND CULTURE
        </ContentStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/RHOOD4.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>

      <ContainerStyle>
        <ContentStyle>This token cannot be bought, only earned.</ContentStyle>
        <ContentStyle>
          By contributing to our community with art, music and creativity you
          will earn your “Culture Maker” status. This creates a separate token,
          with access to all top-tier utilities and forms an exclusive community
          of other creators.
        </ContentStyle>
        <ContentStyle>
          You as a community and token holders will be able to receive funding
          for collaborations with other Culture Maker holders by the R/HOOD
          treasury.
        </ContentStyle>
        <ContentStyle>
          As part of R/HOOD’s roadmap, you as a Culture Maker Holder will also
          get connected with some of the top brands in the world and together
          will R/HOOD be part of creating innovating culture-first campaigns
          with these brands and build on your portfolio.
        </ContentStyle>
        <ContentStyle>
          The Culture Maker Holders will only contain creative people. A
          community by the creators, for the creators. community.
        </ContentStyle>
      </ContainerStyle>

      <TextFlowStyle>
        <TextFlowContentStyle>
          <TextAStyle>
            &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD
          </TextAStyle>
          <TextBStyle>
            &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD&nbsp;
          </TextBStyle>
        </TextFlowContentStyle>
      </TextFlowStyle>
      <Stack sx={{ height: "30px" }}></Stack>
    </Stack>
  );
}
